import { FC } from 'react'

import { NodeViewProps } from '@tiptap/react'

import { Embed as EmbedType } from '@tribeplatform/gql-client/types'
import { useEmbed } from '@tribeplatform/react-sdk/hooks'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../../i18n/components/T.js'
import { Container } from '../Container.js'

export const Embed: FC<NodeViewProps> = props => {
  const { node, deleteNode } = props
  const initialData = node.attrs.embed as EmbedType
  const url = initialData?.url || (node.attrs.url as string)
  const { data: embed } = useEmbed({
    variables: {
      url,
      options: JSON.stringify({
        iframe: '1',
        omit_script: '1',
      }),
    },
    useQueryOptions: {
      initialData,
      enabled: !!initialData?.html,
    },
  })

  if (!embed && !url) {
    return (
      <Container {...props}>
        <T
          id="Generics.SomethingWentWrong"
          defaultMessage="Something went wrong"
        />
      </Container>
    )
  }

  const handleRemove = () => {
    deleteNode()
  }

  return (
    <Container {...props}>
      {embed?.html && (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: embed?.html }}
          className="rounded-base screen-rounded-none overflow-hidden"
        />
      )}
      <IconButton
        as="div"
        icon={<SvgIcon name="close" />}
        variant="secondary"
        size="sm"
        className="!absolute top-0 end-0 m-1 z-10 cursor-pointer"
        onClick={handleRemove}
      />
    </Container>
  )
}
